import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import thunk from 'redux-thunk';

import themeReducer from './app/themeSlice';
import keyReducer from './app/keySlice';
import footerReducer from './app/footerSlice';
import appReducer from './app/appSlice';
import userReducer from './app/userSlice';
import findProviderReducer from './member/findProviderSlice';
import priceCompareReducer from './member/priceCompareSlice';
import breadCrumbReducer from './admin/breadCrumbSlice';
import memberReducer from './member/memberSlice';
import memberModuleReducer from './admin/memberModule';
import claimsReducer from './admin/claimsSlice';
import memberClaimsReducer from './member/memberClaimsSlice';
import userManagementReducer from './admin/userManagementSlice';
import configureLinksReducer from './admin/configureLinksSlice';
import manageResourceReducer from './admin/manageResourceSlice';
import manageContactsReducer from './admin/manageContactsSlice';
import configurePagesReducer from './admin/configurePagesSlice';
import priceCompareReducerAdmin from './admin/priceCompareSlice';
import userTypesReducer from './admin/userTypesSlice';
import uploadDocumentReducer from './member/uploadDocumentSlice';
import uploadDocumentReducerAdmin from './admin/uploadDocumentSlice';
import reportsReducer from './admin/reportsSlice';
import messageAdminReducer from './admin/messageAdminSlice';
import accumulatorSliceReducer from './admin/accumulatorSlice';
import membersReducer from './admin/membersSlice';
import messageAndNotificationReducer from './app/messageAndNotificationSlice';
import enrollmentClientConfigReducer from './member/enrollmentClientConfigSlice';

const appPersistConfig = {
  key: 'app',
  storage: storage,
  keyPrefix: '',
  blacklist: ['loadingNum'],
};

const reducers = combineReducers({
  key: keyReducer,
  theme: themeReducer,
  footer: footerReducer,
  app: persistReducer(appPersistConfig, appReducer),
  user: userReducer,
  breadCrumb: breadCrumbReducer,
  findProvider: findProviderReducer,
  priceCompare: priceCompareReducer,
  priceCompareAdmin: priceCompareReducerAdmin,
  memberSummary: memberReducer,
  memberModule: memberModuleReducer,
  claims: claimsReducer,
  memberClaims: memberClaimsReducer,
  userManagement: userManagementReducer,
  configureLinks: configureLinksReducer,
  manageResource: manageResourceReducer,
  manageContacts: manageContactsReducer,
  configurePages: configurePagesReducer,
  userTypes: userTypesReducer,
  uploadDocument: uploadDocumentReducer,
  uploadDocumentAdmin: uploadDocumentReducerAdmin,
  reports: reportsReducer,
  messageAdmin: messageAdminReducer,
  accumulator: accumulatorSliceReducer,
  members: membersReducer,
  messageAndNotification: messageAndNotificationReducer,
  enrollmentClientConfig: enrollmentClientConfigReducer,
});

const persistConfig = {
  key: 'memberdata',
  storage,
  blacklist: ['footer', 'key', 'findProvider', 'app', 'members'], //Things u dont
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: [thunk],
});

export default store;
